<div class="nav-container">
    <div *ngFor="let step of steppers; let i = index" class="stepper" 
        [ngClass]="{'stepper__checked': i < currentStep, 'stepper__current': i == currentStep, 'stepper__disabled': i > currentStep}">
        <mat-icon *ngIf="i < currentStep" >check</mat-icon>
        <span *ngIf="i >= currentStep" >{{step}}</span>
    </div>
</div>